import _extends from '@babel/runtime/helpers/esm/extends';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _styled from '@emotion/styled-base';
import 'core-js/modules/es6.object.to-string.js';
import 'core-js/modules/es6.array.iterator.js';
import 'core-js/modules/web.dom.iterable.js';
import 'core-js/modules/es6.array.map.js';
import 'core-js/modules/es6.string.includes.js';
import 'core-js/modules/es7.array.includes.js';
import React__default, { forwardRef, useState, useEffect } from 'react';
import { NavigationItem } from '../navigation/navigation-item.js';
import cx from 'classnames';
import { CheckmarkOutline32, CheckmarkFilled32, InProgress32, RadioButton32, StarFilled32, ChevronUp32, ChevronDown32 } from '@carbon/icons-react';
import { Icon } from '../icon/icon.js';
import { textDisabled, intentSuccess, intentPrimary, text, colorSunlightYellow3 } from '../theme/theme.js';
import { useMeasure } from 'react-use';
import { useSpring, animated } from '@react-spring/web';
import { useId } from '@radix-ui/react-id';
import { TooltipV2 } from '../tooltip-v2/tooltip-v2.js';

var _excluded = ["status"],
    _excluded2 = ["activeStepId", "children", "disabledItemTooltipText", "onClick", "expanded", "ordered", "status", "t"],
    _excluded3 = ["activeStepId", "className", "disabledItemTooltipText", "lastItemHasStar", "expandedItems", "ordered", "stepperItems", "t"];
var TranslationKeys;

(function (TranslationKeys) {
  TranslationKeys["StepperItemDisabledTooltip"] = "varicent-design-system.vds-stepper.vds-stepper-item-disabled-tooltip";
})(TranslationKeys || (TranslationKeys = {}));

var defaultTranslation = _defineProperty({}, TranslationKeys.StepperItemDisabledTooltip, function () {
  return "Unavailable until you complete the previous step";
});

var defaultTranslate = function defaultTranslate(arg) {
  return defaultTranslation[arg.id](arg.values);
};

var StepperStatus;

(function (StepperStatus) {
  StepperStatus[StepperStatus["Unstarted"] = 0] = "Unstarted";
  StepperStatus[StepperStatus["Started"] = 1] = "Started";
  StepperStatus[StepperStatus["Complete"] = 2] = "Complete";
  StepperStatus[StepperStatus["None"] = 3] = "None";
})(StepperStatus || (StepperStatus = {}));

var StepperListItem = /*#__PURE__*/_styled("li", {
  target: "egawuuj0"
})({
  name: "k5vkhq",
  styles: "list-style:none;position:relative;.vds-stepper-list{padding-bottom:0.25rem;margin-left:2rem;}"
});

var StyledNavigationItem = /*#__PURE__*/_styled(function (_ref) {
  _ref.status;
      var otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default.createElement(NavigationItem, otherProps);
}, {
  target: "egawuuj1"
})("margin-bottom:0.25rem;&::after{content:\"\";position:absolute;top:1.75rem;left:1.25rem;width:1px;height:calc(100% - 0.75rem);transform:translateX(-50%);background-color:", function (_ref2) {
  var status = _ref2.status;
  return status === "disabled" ? textDisabled : status === StepperStatus.Complete ? intentSuccess : status === StepperStatus.Started ? intentPrimary : text;
}, ";}&[aria-controls]::after{height:calc(100% - 1rem);}.vds-stepper-list-item:last-of-type &::after,& + div .vds-stepper-list .vds-stepper-link::after{content:none;}& + div .vds-stepper-list .vds-stepper-link:focus{outline-offset:-2px;}");

var createLeftElementIcon = function createLeftElementIcon(_ref3) {
  var element = _ref3.element,
      _ref3$isChild = _ref3.isChild,
      isChild = _ref3$isChild === void 0 ? false : _ref3$isChild,
      _ref3$isDisabled = _ref3.isDisabled,
      isDisabled = _ref3$isDisabled === void 0 ? false : _ref3$isDisabled,
      _ref3$isLastItem = _ref3.isLastItem,
      isLastItem = _ref3$isLastItem === void 0 ? false : _ref3$isLastItem,
      _ref3$lastItemHasStar = _ref3.lastItemHasStar,
      lastItemHasStar = _ref3$lastItemHasStar === void 0 ? false : _ref3$lastItemHasStar;
  var leftElementIcon;
  var leftElementIconColor;

  if (element.status === StepperStatus.Complete) {
    leftElementIcon = isChild ? /*#__PURE__*/React__default.createElement(CheckmarkOutline32, null) : /*#__PURE__*/React__default.createElement(CheckmarkFilled32, null);
    leftElementIconColor = intentSuccess;
  } else if (element.status === StepperStatus.Started) {
    leftElementIcon = /*#__PURE__*/React__default.createElement(InProgress32, null);
    leftElementIconColor = intentPrimary;
  } else {
    leftElementIcon = /*#__PURE__*/React__default.createElement(RadioButton32, null);
    leftElementIconColor = text;
  }

  if (isDisabled) {
    leftElementIconColor = textDisabled;
  }

  if (isLastItem && lastItemHasStar) {
    leftElementIcon = /*#__PURE__*/React__default.createElement(StarFilled32, null);
    leftElementIconColor = "rgb(".concat(colorSunlightYellow3, ")");
  }

  return /*#__PURE__*/React__default.createElement(Icon, {
    style: {
      color: leftElementIconColor
    }
  }, leftElementIcon);
};

var ExpandableNavigationItem = function ExpandableNavigationItem(_ref4) {
  var activeStepId = _ref4.activeStepId,
      children = _ref4.children,
      disabledItemTooltipText = _ref4.disabledItemTooltipText,
      _onClick = _ref4.onClick,
      expanded = _ref4.expanded,
      ordered = _ref4.ordered,
      status = _ref4.status,
      _ref4$t = _ref4.t,
      t = _ref4$t === void 0 ? defaultTranslate : _ref4$t,
      props = _objectWithoutProperties(_ref4, _excluded2);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      childrenHeight = _useState4[0],
      setChildrenHeight = _useState4[1];

  var _useMeasure = useMeasure(),
      _useMeasure2 = _slicedToArray(_useMeasure, 2),
      childrenRef = _useMeasure2[0],
      height = _useMeasure2[1].height;

  var childrenId = useId();
  var expand = useSpring({
    config: {
      friction: 20
    },
    height: open ? "".concat(childrenHeight, "px") : "0px",
    overflow: "hidden"
  });
  useEffect(function () {
    setOpen(!!expanded);
    setChildrenHeight(height);
  }, [expanded, height]);
  var StepperList = ordered ? "ol" : "ul";
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledNavigationItem, _extends({
    "aria-controls": !!children ? "vds-stepper-list-".concat(childrenId) : undefined,
    "aria-expanded": !!children ? open : undefined,
    onClick: function onClick() {
      setOpen(function (prev) {
        return !prev;
      });
      _onClick && _onClick();
    },
    rightElement: !!children && !props.disabled && /*#__PURE__*/React__default.createElement(Icon, null, open ? /*#__PURE__*/React__default.createElement(ChevronUp32, null) : /*#__PURE__*/React__default.createElement(ChevronDown32, null)),
    tabIndex: !props.disabled ? 0 : -1,
    status: props.disabled ? "disabled" : status,
    style: {
      fontWeight: "bold"
    }
  }, props)), children && /*#__PURE__*/React__default.createElement(animated.div, {
    role: "presentation",
    style: expand
  }, /*#__PURE__*/React__default.createElement(StepperList, {
    "aria-hidden": !open,
    className: "vds-stepper-list",
    id: "vds-stepper-list-".concat(childrenId),
    ref: childrenRef
  }, children.map(function (child, index, childrenArray) {
    var previousChild = childrenArray[index - 1];
    var isDisabled = ordered && (previousChild && previousChild.status !== StepperStatus.Complete || props.disabled);
    return /*#__PURE__*/React__default.createElement(TooltipV2, {
      content: isDisabled ? disabledItemTooltipText ? disabledItemTooltipText : t({
        id: TranslationKeys.StepperItemDisabledTooltip
      }) : undefined,
      key: "".concat(child.id, "-tooltip")
    }, /*#__PURE__*/React__default.createElement(StepperListItem, {
      className: "vds-stepper-list-item"
    }, /*#__PURE__*/React__default.createElement(StyledNavigationItem, {
      active: child.id === activeStepId,
      className: "vds-stepper-link",
      disabled: isDisabled,
      leftElement: createLeftElementIcon({
        element: child,
        isChild: true,
        isDisabled: isDisabled
      }),
      onClick: child.onClick,
      status: isDisabled ? "disabled" : child.status,
      tabIndex: open && !isDisabled ? 0 : -1,
      text: child.label
    })));
  }))));
};

var Stepper = /*#__PURE__*/forwardRef(function (_ref5, ref) {
  var activeStepId = _ref5.activeStepId,
      className = _ref5.className,
      disabledItemTooltipText = _ref5.disabledItemTooltipText,
      lastItemHasStar = _ref5.lastItemHasStar,
      expandedItems = _ref5.expandedItems,
      ordered = _ref5.ordered,
      stepperItems = _ref5.stepperItems,
      _ref5$t = _ref5.t,
      t = _ref5$t === void 0 ? defaultTranslate : _ref5$t,
      props = _objectWithoutProperties(_ref5, _excluded3);

  var StepperList = ordered ? "ol" : "ul";
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: cx("vds-stepper", className),
    ref: ref
  }, props), /*#__PURE__*/React__default.createElement(StepperList, {
    className: "vds-stepper-list"
  }, stepperItems.map(function (item, index, itemsArray) {
    var previousItem = itemsArray[index - 1];
    var isDisabled = ordered && previousItem && previousItem.status !== StepperStatus.Complete;
    var isLastItem = index === itemsArray.length - 1;
    return /*#__PURE__*/React__default.createElement(TooltipV2, {
      content: isDisabled ? disabledItemTooltipText ? disabledItemTooltipText : t({
        id: TranslationKeys.StepperItemDisabledTooltip
      }) : undefined,
      key: "".concat(item.id, "-tooltip")
    }, /*#__PURE__*/React__default.createElement(StepperListItem, {
      className: "vds-stepper-list-item"
    }, /*#__PURE__*/React__default.createElement(ExpandableNavigationItem, {
      active: item.id === activeStepId,
      activeStepId: activeStepId,
      children: item.children,
      className: "vds-stepper-link",
      disabled: isDisabled,
      disabledItemTooltipText: disabledItemTooltipText,
      expanded: !isDisabled && (expandedItems === null || expandedItems === void 0 ? void 0 : expandedItems.includes(item.id)),
      leftElement: createLeftElementIcon({
        element: item,
        isDisabled: isDisabled,
        isLastItem: isLastItem,
        lastItemHasStar: lastItemHasStar
      }),
      onClick: item.onClick,
      ordered: ordered,
      status: item.status,
      t: t,
      text: item.label
    })));
  })));
});

export { Stepper, StepperStatus };
//# sourceMappingURL=stepper.js.map
